module.exports = __webpack_public_path__ + "clinic.3ec336543ce89a67eab9.svg";


//////////////////
// WEBPACK FOOTER
// D:/My Projects/2023/eCompound/unimas-request-web/src/assets/fonts/clinic.svg
// module id = ../../../../../src/assets/fonts/clinic.svg
// module chunks = styles